import {AbstractControl} from "@angular/forms";

export function getFlagClass(languageName: string): string {
  const name = languageName.toLowerCase();
  const flagKey = name === 'english' ? 'gb' : name.substring(0, 2);
  return `flag-icon flag-icon-${flagKey}`;
}


export function getErrorMessage(formField: AbstractControl | null): string {
  if (!formField) return '';
  if (!formField.touched && !formField.dirty) return '';

  return formField.hasError('required') ?
    'Field is required.' :
    formField.hasError('email') ?
    'Enter a valid email address.' :
    formField.hasError('tum.de') ?
    'Email address must end in "tum.de" or "mytum.de".' :
    formField.hasError('minlength') ?
    'Password must contain at least 5 characters.' :
    formField.hasError('uppercaseLetter') ?
    'Password must contain an uppercase letter.' :
    formField.hasError('specialCharacter') ?
    'Password must contain a special character.' :
    formField.hasError('passwordsDoNotMatch') ?
    'Passwords do not match.' : '';
}
